import { DEFAULT_HEIGHT, DEFAULT_WIDTH } from './constant';
import { IMetadataMap } from './types';
import KamereoLogo from '../../../images/KamereoLogo.png';

export const recommendedForYouKey = 'RECOMMENDED_FOR_YOU';

export const businessCategoryVI: Record<string, string> = {
  RESTAURANT_CHAIN: 'Chuỗi Nhà Hàng',
  RESTAURANT_CHINESE: 'Nhà Hàng Trung Quốc',
  RESTAURANT_JAPANESE: 'Nhà Hàng Nhật Bản',
  RESTAURANT_KOREAN: 'Nhà Hàng Hàn Quốc',
  RESTAURANT_THAI: 'Nhà Hàng Thái',
  RESTAURANT_VEGETARIAN: 'Nhà Hàng Chay',
  RESTAURANT_VIETNAMESE: 'Nhà Hàng Việt',
  RESTAURANT_WESTERN: 'Nhà Hàng Tây',
  CAFE_BAKERY_CHAIN: 'Chuỗi Cà Phê - Bánh',
  CAFE_BAKERY_INDEPENDENT: 'Quán Cà Phê - Bánh',
  BAR_PUB: 'Bar - Pub',
  NIGHT_CLUB: 'Hộp Đêm',
  HOTEL_1_3_STAR: 'Khách Sạn 1 - 3 Sao',
  HOTEL_4_5_STAR: 'Khách Sạn 4 - 5 Sao',
  HOTEL_NORMAL: 'Khách Sạn Bình Dân',
  CONVENIENT_STORE: 'Cửa Hàng Tiện Lợi',
  SUPER_MARKET: 'Siêu Thị',
  FINE_RETAIL: 'Fine Retail',
  TRADITIONAL_RETAIL: 'Bán Lẻ Truyền Thống',
  RETAIL_E_COMMERCE: 'Bản Lẻ E-com',
  WHOLESALER: 'Bản sỉ',
  CATERING_AND_CANTEEN: 'Căn Tin',
  FACTORY: 'Nhà Máy',
  SCHOOL: 'Trường Học',
  HOSPITAL: 'Bệnh Viện',
  OFFICE: 'Văn Phòng',
  GYM: 'Gym',
  CONVENTION_CENTER: 'Trung Tâm Hội Nghị - Tiệc Cưới',
  TAKE_AWAY_ONLINE_KITCHEN: 'Bán Online - Mang Đi',
  DRINK_RESTAURANT: 'Quán Nhậu',
  FOOD_STORE: 'Quán cơm / Bún / Phở',
};

export const businessCategoryEN: Record<string, string> = {
  RESTAURANT_CHAIN: 'Restaurant Chain',
  RESTAURANT_CHINESE: 'Restaurant Chinese',
  RESTAURANT_JAPANESE: 'Restaurant Japanese',
  RESTAURANT_KOREAN: 'Restaurant Korean',
  RESTAURANT_THAI: 'Restaurant Thai',
  RESTAURANT_VEGETARIAN: 'Restaurant Vegetarian',
  RESTAURANT_VIETNAMESE: 'Restaurant Vietnamese',
  RESTAURANT_WESTERN: 'Restaurant Western',
  CAFE_BAKERY_CHAIN: 'Cafe - Bakery Chain',
  CAFE_BAKERY_INDEPENDENT: 'Cafe - Bakery Independent',
  BAR_PUB: 'Bar - Pub',
  NIGHT_CLUB: 'Night Club',
  HOTEL_1_3_STAR: 'Hotel 1 - 3 Star',
  HOTEL_4_5_STAR: 'Hotel 4 - 5 Star',
  HOTEL_NORMAL: 'Hotel Normal',
  CONVENIENT_STORE: 'Convenient Store',
  SUPER_MARKET: 'Supermarket',
  FINE_RETAIL: 'Fine Retail',
  TRADITIONAL_RETAIL: 'Traditional Retail',
  RETAIL_E_COMMERCE: 'Retail E-Commerce',
  WHOLESALER: 'Wholesaler',
  CATERING_AND_CANTEEN: 'Catering&Canteen',
  FACTORY: 'Factory',
  SCHOOL: 'School',
  HOSPITAL: 'Hospital',
  OFFICE: 'Office',
  GYM: 'Gym',
  CONVENTION_CENTER: 'Convention Center',
  TAKE_AWAY_ONLINE_KITCHEN: 'Take Away - Online Kitchen',
  DRINK_RESTAURANT: 'Drink Restaurant',
  FOOD_STORE: 'Food Store',
};

export const getRecommendedMetadata = (businessCategory?: string) => {
  const categoryNameVI = businessCategory ? businessCategoryVI[businessCategory] : null;
  const categoryNameEN = businessCategory ? businessCategoryEN[businessCategory] : null;

  if (businessCategory && categoryNameVI && categoryNameEN) {
    return {
      en: {
        image: {
          url: KamereoLogo,
          height: DEFAULT_HEIGHT,
          width: DEFAULT_WIDTH,
        },
        title: `${categoryNameEN} | Buy Good Deals at Kamereo`,
        description:
          'Cung cấp nguyên liệu, vật dụng cho Nhà Hàng, Cà Phê, Bar, Khách Sạn, Siêu Thị,... Nguồn hàng phong phú, ổn định. Giao Hàng Tận Nơi. Có giấy chứng nhận VSATTP',
      },
      vi: {
        image: {
          url: KamereoLogo,
          height: DEFAULT_HEIGHT,
          width: DEFAULT_WIDTH,
        },
        title: `${categoryNameVI} | Nhập hàng Giá Tốt tại Kamereo`,
        description:
          'Cung cấp nguyên liệu, vật dụng cho Nhà Hàng, Cà Phê, Bar, Khách Sạn, Siêu Thị,... Nguồn hàng phong phú, ổn định. Giao Hàng Tận Nơi. Có giấy chứng nhận VSATTP',
      },
    };
  }

  return {
    en: {
      image: {
        url: KamereoLogo,
        height: DEFAULT_HEIGHT,
        width: DEFAULT_WIDTH,
      },
      title: 'Recommended For You | Buy Good Deals, Quality at Kamereo',
      description:
        'Cung cấp nguyên liệu, vật dụng cho Nhà Hàng, Cà Phê, Bar, Khách Sạn, Siêu Thị,... Nguồn hàng phong phú, ổn định. Giao Hàng Tận Nơi. Có giấy chứng nhận VSATTP',
    },
    vi: {
      image: {
        url: KamereoLogo,
        height: DEFAULT_HEIGHT,
        width: DEFAULT_WIDTH,
      },
      title: 'Đề xuất cho bạn | Nhập hàng Giá Tốt, Chất Lượng tại Kamereo',
      description:
        'Cung cấp nguyên liệu, vật dụng cho Nhà Hàng, Cà Phê, Bar, Khách Sạn, Siêu Thị,... Nguồn hàng phong phú, ổn định. Giao Hàng Tận Nơi. Có giấy chứng nhận VSATTP',
    },
  };
};

const recommendedForYou: IMetadataMap = {
  RECOMMENDED_FOR_YOU: getRecommendedMetadata(),
};

export default recommendedForYou;
